import {
  type GroupAttribute,
  type GroupAttributeProductType,
} from '../categories/aliases';

function formatDepartmentName(department: string): string {
  const withoutWear = department.replace(/wear$/i, '');

  if (withoutWear.toLowerCase() === `kids`) {
    return `Kids'`;
  }
  const withoutTrailingS = withoutWear.replace(/s$/i, '');
  return `${withoutTrailingS.charAt(0).toUpperCase()}${withoutTrailingS.slice(1)}'s`;
}

function getGroupName(
  groupInfo: GroupAttribute | GroupAttributeProductType
): string {
  return groupInfo.name_i18n['en-US'] || groupInfo.name_i18n.en || groupInfo.id;
}

export function capitalizeDepartment(department: string): string {
  return department.charAt(0).toUpperCase() + department.slice(1);
}

function isEverythingElseDepartment(department: string): boolean {
  return department.toLowerCase().includes('everything-else');
}

export function removeHyphensExceptTShirts(name: string): string {
  const placeholder = '__T_SHIRTS_PLACEHOLDER__';
  const withPlaceholder = name.replace(/t-shirts/gi, placeholder);
  const withoutHyphens = withPlaceholder.replace(/-/g, ' ');
  return withoutHyphens.replace(new RegExp(placeholder, 'gi'), 't-shirts');
}

export function getGroupNameWithDepartment(
  group: GroupAttribute,
  department: string
): string {
  let groupName = getGroupName(group);
  groupName = removeHyphensExceptTShirts(groupName);

  if (isEverythingElseDepartment(department)) {
    return groupName;
  }
  const departmentName = formatDepartmentName(department);
  return `${departmentName} ${groupName.toLowerCase()}`;
}

export function getProductTypeNameWithDepartment(
  productType: GroupAttributeProductType,
  department: string
): string {
  let productTypeName = getGroupName(productType);
  productTypeName = removeHyphensExceptTShirts(productTypeName);

  if (isEverythingElseDepartment(department)) {
    return productTypeName;
  }
  const departmentName = formatDepartmentName(department);
  return `${departmentName} ${productTypeName.toLowerCase()}`;
}

export function filterProductTypesForDepartment(
  productTypes: GroupAttributeProductType[],
  department: string
): GroupAttributeProductType[] {
  return productTypes.filter((productType) => {
    const productTypeId = productType.id.toLowerCase();
    const productTypeName = getGroupName(productType).toLowerCase();

    if (productTypeId === 'other' || productTypeName === 'other') {
      return false;
    }

    // A product type that lists no departments is valid in every department.
    if (!productType.department?.length) {
      return true;
    }

    return productType.department.includes(department);
  });
}
